export { default as AttributeBadge } from "./AttributeBadge";
